import { QueryClient } from "@tanstack/react-query";

/**
 * Global QueryClient.
 *
 * Defaults are conservative — actual polling cadence is decided per-hook with
 * `refetchInterval: 30_000` (see useStatus). This file deliberately does NOT
 * set a global refetchInterval, because (a) not every future query should poll
 * and (b) keeping the polling cadence local to the status hook makes the
 * contract more visible at the call site.
 *
 * - staleTime 0           : every mount considers data stale → triggers refetch
 *                           once the component appears; the 30s interval owns
 *                           steady-state freshness.
 * - retry 1               : one quick retry on transient failure, then fall
 *                           through to error state so the UI can surface
 *                           "Connection issue, showing last known data".
 * - refetchOnWindowFocus  : refetch when the user comes back to the tab.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});
